import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import MobileView from './mobileView';
import { Headers, TableBody, UserFilters } from './tableInfo';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getUsers } from '../../redux/State/userSlice';

const AllUsers = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();

	const [params] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const orderBy = params.get('orderBy') || '';
	const direction = params.get('direction') || '';
	const searchString = params.get('search') || '';
	const section = params.get('status');

	const usersData = useSelector((state) => state.user.users);
	const loading = useSelector((state) => state.user.loading);

	useEffect(() => {
		dispatch(getUsers({ page, pageSize, orderBy, direction, searchString, section }));
	}, [page, pageSize, orderBy, direction, searchString, section, dispatch]);

	const addAdminHandler = () => {
		window.localStorage.removeItem('formType');
		navigate('/user/new');
	};

	return (
		<Container>
			<Header>
				<CustomButton title="Add User" className="marginRight16" onClick={addAdminHandler} />
				<SearchBar hasFilter style={{ marginTop: 0 }} />
				<UserFilters />
			</Header>
			<CustomTable headers={Headers} data={usersData} TableBody={TableBody} loading={loading} />
			<MobileView {...usersData} />
		</Container>
	);
};

export default AllUsers;
